import {
    Breadcrumbs,
    Button,
    Chip,
    Collapse,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";

import { emphasize, styled } from '@mui/material/styles';
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MyContext } from "../../App";
import { deleteData, fetchDataFromApi } from "../../utils/api";


// ================= Breadcrumb =================
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];

    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});


// ================= Component =================
const ProductFinish = () => {

    const [productfinishData, setProductfinishData] = useState([])
    const [openDropdown, setOpenDropdown] = useState({});

    // 🔥 single dialog for all deletes
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteAction, setDeleteAction] = useState(null);
    const [deleteText, setDeleteText] = useState("");

    const context = useContext(MyContext)


    // ================= Fetch =================
    useEffect(() => {
        window.scrollTo(0, 0)

        context.setProgress(20)

        fetchDataFromApi('/api/productfinish').then(res => {
            setProductfinishData(res?.productfinishes || [])
            context.setProgress(100)
        })
    }, [])


    const refresh = () => {
        fetchDataFromApi('/api/productfinish')
            .then(res => setProductfinishData(res?.productfinishes || []));
    };


    const toggleDropdown = (productId) => {
        setOpenDropdown((prev) => ({ ...prev, [productId]: !prev[productId] }));
    };


    // ================= Ask Delete =================
    const askDelete = (message, action) => {
        setDeleteText(message);
        setDeleteAction(() => action);
        setOpenDelete(true);
    };


    // ================= Confirm Delete =================
    const confirmDelete = () => {
        if (deleteAction) deleteAction();
        setOpenDelete(false);
    };


    return (
        <>
            <div className="right-content w-100">

                {/* ================= Header ================= */}
                <div className="card shadow border-0 w-100 flex-row p-4">
                    <h5 className="mb-0">Product Finish List</h5>

                    <div className="ml-auto d-flex align-items-center">
                        <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
                            <StyledBreadcrumb
                                component="a"
                                href="#"
                                label="Dashboard"
                                icon={<HomeIcon fontSize="small" />}
                            />
                            <StyledBreadcrumb
                                label="Product Finish"
                                deleteIcon={<ExpandMoreIcon />}
                            />
                        </Breadcrumbs>

                        <Link to="/productFinish/add">
                            <Button className="btn-blue ml-3 pl-3 pr-3">
                                Add Product Finish
                            </Button>
                        </Link>
                    </div>
                </div>


                {/* ================= Table ================= */}
                <div className="card shadow border-0 p-3 mt-4">
                    <div className="table-responsive mt-3">

                        <table className="table table-bordered v-align">
                            <thead className="thead-dark">
                                <tr>
                                    <th>PRODUCT</th>
                                    <th>CODE</th>
                                    <th>FINISHES</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    productfinishData?.length > 0 ? productfinishData.map((item) => (
                                        <React.Fragment key={item._id}>
                                            <tr>
                                                <td>{item.productId?.name}</td>
                                                <td>{item.productId?.code}</td>

                                                {/* ===== Finish Dropdown ===== */}
                                                <td>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => toggleDropdown(item._id)}
                                                        style={{ textTransform: "none" }}
                                                    >
                                                        {openDropdown[item._id] ? "Hide Finishes" : "Show Finishes"}
                                                    </Button>

                                                    <Collapse in={openDropdown[item._id]}>
                                                        <table className="table table-bordered mt-2">
                                                            <thead className="thead-dark">
                                                                <tr>
                                                                    <th>FINISH NAME</th>
                                                                    <th>ACTION</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {item.finishes.map((finish) => (
                                                                    <tr key={finish._id}>
                                                                        <td>{finish.name?.name}</td>
                                                                        <td>
                                                                            <div className="actions d-flex align-items-center">
                                                                                <Button
                                                                                    className="error"
                                                                                    color="error"
                                                                                    onClick={() =>
                                                                                        askDelete(
                                                                                            "Delete this Finish?",
                                                                                            () =>
                                                                                                deleteData(
                                                                                                    `/api/productfinish/${item.productId._id}/${finish.name._id}`
                                                                                                ).then(() => {
                                                                                                    context.setAlertBox({
                                                                                                        open: true,
                                                                                                        error: true,
                                                                                                        msg: "Finish Deleted!"
                                                                                                    });
                                                                                                    refresh();
                                                                                                })
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <MdDelete />
                                                                                </Button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </Collapse>
                                                </td>

                                                {/* ===== Delete Whole Product ===== */}
                                                <td>
                                                    <div className="actions d-flex align-items-center">
                                                        <Button
                                                            className="error"
                                                            color="error"
                                                            onClick={() =>
                                                                askDelete(
                                                                    "Delete entire Product Finish?",
                                                                    () =>
                                                                        deleteData(`/api/productfinish/${item.productId._id}`).then(() => {
                                                                            context.setAlertBox({
                                                                                open: true,
                                                                                error: true,
                                                                                msg: "ProductFinish Deleted!"
                                                                            });
                                                                            refresh();
                                                                        })
                                                                )
                                                            }
                                                        >
                                                            <MdDelete />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    )) : (
                                        <tr>
                                            <td colSpan="3" className="text-center">
                                                No Product Finishes Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


            {/* ================= Confirm Dialog ================= */}
            <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>

                <DialogContent>
                    {deleteText}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDelete(false)}>
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={confirmDelete}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ProductFinish;
